import React from 'react'
import { AUTH_PREFIX_PATH, APP_PREFIX_PATH } from 'configs/AppConfig'

export const publicRoutes = [
    {
        key: 'admin-login',
        path: `${AUTH_PREFIX_PATH}/admin/login`,
        component: React.lazy(() => import('views/auth-views/authentication/admin-login')),
    },
    {
        key: 'admin-send-reset-email',
        path: `${AUTH_PREFIX_PATH}/admin/send-reset-email`,
        component: React.lazy(() => import('views/auth-views/authentication/admin-send-reset-email')),
    },
    {
        key: 'admin-verify-otp',
        path: `${AUTH_PREFIX_PATH}/admin/verify-otp`,
        component: React.lazy(() => import('views/auth-views/authentication/admin-verify-otp')),
    },
    {
        key: 'admin-reset-password',
        path: `${AUTH_PREFIX_PATH}/admin/reset-password`,
        component: React.lazy(() => import('views/auth-views/authentication/admin-reset-password')),
    },
    {
        key: 'admin-redirect',
        path: `${AUTH_PREFIX_PATH}/admin`,
        component: React.lazy(() => import('views/auth-views/components/AdminRedirect')),
    },
    {
        key: 'login',
        path: `${AUTH_PREFIX_PATH}/login`,
        component: React.lazy(() => import('views/auth-views/authentication/login')),
    },
    {
        key: 'agent-login',
        path: `${AUTH_PREFIX_PATH}/agent-login`,
        component: React.lazy(() => import('views/auth-views/authentication/agent-login')),
    },
    {
        key: 'login-1',
        path: `${AUTH_PREFIX_PATH}/login-1`,
        component: React.lazy(() => import('views/auth-views/authentication/login-1')),
    },
    {
        key: 'login-2',
        path: `${AUTH_PREFIX_PATH}/login-2`,
        component: React.lazy(() => import('views/auth-views/authentication/login-2')),
    },
    {
        key: 'register-1',
        path: `${AUTH_PREFIX_PATH}/register-1`,
        component: React.lazy(() => import('views/auth-views/authentication/register-1')),
    },
    {
        key: 'register-2',
        path: `${AUTH_PREFIX_PATH}/register-2`,
        component: React.lazy(() => import('views/auth-views/authentication/register-2')),
    },
    {
        key: 'forgot-password',
        path: `${AUTH_PREFIX_PATH}/forgot-password`,
        component: React.lazy(() => import('views/auth-views/authentication/forgot-password')),
    },
    {
        key: 'activate-account',
        path: `${AUTH_PREFIX_PATH}/activate-account`,
        component: React.lazy(() => import('views/auth-views/authentication/activate-account')),
    },
    // Redirection pour les anciens liens sans /auth
    {
        key: 'activate-account-legacy',
        path: '/activate-account',
        component: React.lazy(() => import('views/auth-views/components/ActivateAccountRedirect')),
    },
    {
        key: 'send-reset-email',
        path: `${AUTH_PREFIX_PATH}/send-reset-email`,
        component: React.lazy(() => import('views/auth-views/authentication/send-reset-email')),
    },
    {
        key: 'verify-otp',
        path: `${AUTH_PREFIX_PATH}/verify-otp`,
        component: React.lazy(() => import('views/auth-views/authentication/verify-otp')),
    },
    {
        key: 'reset-password',
        path: `${AUTH_PREFIX_PATH}/reset-password`,
        component: React.lazy(() => import('views/auth-views/authentication/reset-password')),
    },
    {
        key: 'error-page-1',
        path: `${AUTH_PREFIX_PATH}/error-page-1`,
        component: React.lazy(() => import('views/auth-views/errors/error-page-1')),
    },
    {
        key: 'error-page-2',
        path: `${AUTH_PREFIX_PATH}/error-page-2`,
        component: React.lazy(() => import('views/auth-views/errors/error-page-2')),
    },
]

export const protectedRoutes = [
    {
        key: 'dashboard.admin',
        path: `${APP_PREFIX_PATH}/dashboards/admin`,
        component: React.lazy(() => import('views/app-views/dashboards/admin')),
    },
    {
        key: 'dashboard.user',
        path: `${APP_PREFIX_PATH}/dashboards/user`,
        component: React.lazy(() => import('views/app-views/dashboards/user')),
    },
    {
        key: 'dashboard.reports',
        path: `${APP_PREFIX_PATH}/dashboards/reports`,
        component: React.lazy(() => import('views/app-views/dashboards/reports')),
    },
    {
        key: 'admin.users',
        path: `${APP_PREFIX_PATH}/admin/users`,
        component: React.lazy(() => import('views/app-views/admin/users')),
    },
    {
        key: 'admin.plans',
        path: `${APP_PREFIX_PATH}/admin/plans`,
        component: React.lazy(() => import('views/app-views/admin/plans')),
    },
    {
        key: 'admin.payment-gateway',
        path: `${APP_PREFIX_PATH}/admin/payment-gateway`,
        component: React.lazy(() => import('views/app-views/admin/payment-gateway')),
    },
    {
        key: 'admin.partnerships',
        path: `${APP_PREFIX_PATH}/admin/partnerships`,
        component: React.lazy(() => import('views/app-views/admin/partnerships')),
    },
    {
        key: 'admin.front-partner',
        path: `${APP_PREFIX_PATH}/admin/front-partner`,
        component: React.lazy(() => import('views/app-views/admin/front-partner')),
    },
    {
        key: 'admin.orders',
        path: `${APP_PREFIX_PATH}/admin/orders`,
        component: React.lazy(() => import('views/app-views/admin/orders')),
    },
    {
        key: 'admin.leads',
        path: `${APP_PREFIX_PATH}/admin/leads`,
        component: React.lazy(() => import('views/app-views/admin/leads')),
    },
    {
        key: 'admin.appearance-settings',
        path: `${APP_PREFIX_PATH}/admin/appearance-settings`,
        component: React.lazy(() => import('views/app-views/admin/appearance-settings')),
    },
    {
        key: 'admin.smtp-settings',
        path: `${APP_PREFIX_PATH}/admin/smtp-settings`,
        component: React.lazy(() => import('views/app-views/admin/smtp-settings')),
    },
    {
        key: 'voice.dialer',
        path: `${APP_PREFIX_PATH}/voice/dialer`,
        component: React.lazy(() => import('views/app-views/voice/dialer')),
    },
    {
        key: 'voice.prepare-device',
        path: `${APP_PREFIX_PATH}/voice/prepare-device`,
        component: React.lazy(() => import('views/app-views/voice/prepare-device')),
    },
    {
        key: 'voice.incoming-calls',
        path: `${APP_PREFIX_PATH}/voice/incoming-calls`,
        component: React.lazy(() => import('views/app-views/voice/incoming-calls')),
    },
    {
        key: 'productivity.phonebook',
        path: `${APP_PREFIX_PATH}/productivity/phonebook`,
        component: React.lazy(() => import('views/app-views/productivity/phonebook')),
    },
    {
        key: 'productivity.agent',
        path: `${APP_PREFIX_PATH}/productivity/agent-management`,
        component: React.lazy(() => import('views/app-views/productivity/agent-management')),
    },
    {
        key: 'productivity.staff-management',
        path: `${APP_PREFIX_PATH}/productivity/staff-management`,
        component: React.lazy(() => import('views/app-views/productivity/staff-management')),
    },
    {
        key: 'productivity.clients',
        path: `${APP_PREFIX_PATH}/productivity/clients`,
        component: React.lazy(() => import('views/app-views/productivity/clients')),
    },
    {
        key: 'productivity.client-stats',
        path: `${APP_PREFIX_PATH}/productivity/client-stats/:clientId`,
        component: React.lazy(() => import('views/app-views/productivity/client-stats')),
    },
    {
        key: 'client.dashboard',
        path: `${APP_PREFIX_PATH}/client/dashboard`,
        component: React.lazy(() => import('views/app-views/productivity/client-stats')),
    },
    {
        key: 'config.device-manager',
        path: `${APP_PREFIX_PATH}/config/device-manager`,
        component: React.lazy(() => import('views/app-views/config/device-manager')),
    },
    {
        key: 'config.subscription',
        path: `${APP_PREFIX_PATH}/config/subscription`,
        component: React.lazy(() => import('views/app-views/config/subscription')),
    },
    {
        key: 'config.smtp',
        path: `${APP_PREFIX_PATH}/config/smtp`,
        component: React.lazy(() => import('views/app-views/config/smtp')),
    },
    {
        key: 'config.role-management',
        path: `${APP_PREFIX_PATH}/config/role-management`,
        component: React.lazy(() => import('views/app-views/config/role-management')),
    },
    {
        key: 'voice-agent.create-flow',
        path: `${APP_PREFIX_PATH}/voice-agent/create-flow`,
        component: React.lazy(() => import('views/app-views/voice-agent/create-flow')),
    },
    {
        key: 'voice-agent.setup',
        path: `${APP_PREFIX_PATH}/voice-agent/setup`,
        component: React.lazy(() => import('views/app-views/voice-agent/setup')),
    },
    {
        key: 'voice-agent.workflow-tester',
        path: `${APP_PREFIX_PATH}/voice-agent/workflow-tester`,
        component: React.lazy(() => import('views/app-views/voice-agent/workflow-tester')),
    },
    {
        key: 'voice-agent.appointments',
        path: `${APP_PREFIX_PATH}/voice-agent/appointments`,
        component: React.lazy(() => import('views/app-views/voice-agent/appointments')),
    },
    {
        key: 'voice-agent.workflow-call-logs',
        path: `${APP_PREFIX_PATH}/voice-agent/workflow-call-logs`,
        component: React.lazy(() => import('views/app-views/voice-agent/workflow-call-logs')),
    },
    {
        key: 'agent.dashboard',
        path: `${APP_PREFIX_PATH}/agent/dashboard`,
        component: React.lazy(() => import('views/app-views/agent/dashboard')),
    },
    {
        key: 'agent.dialer',
        path: `${APP_PREFIX_PATH}/agent/dialer`,
        component: React.lazy(() => import('views/app-views/agent/dialer')),
    },
    {
        key: 'agent.incoming-calls',
        path: `${APP_PREFIX_PATH}/agent/incoming-calls`,
        component: React.lazy(() => import('views/app-views/agent/incoming-calls')),
    },
    {
        key: 'agent.call-history',
        path: `${APP_PREFIX_PATH}/agent/call-history`,
        component: React.lazy(() => import('views/app-views/agent/call-history')),
    },
    {
        key: 'agent.contacts',
        path: `${APP_PREFIX_PATH}/agent/contacts`,
        component: React.lazy(() => import('views/app-views/agent/contacts')),
    },
    {
        key: 'agent.appointments',
        path: `${APP_PREFIX_PATH}/agent/appointments`,
        component: React.lazy(() => import('views/app-views/voice-agent/appointments')),
    },
    {
        key: 'agent.profile',
        path: `${APP_PREFIX_PATH}/agent/profile`,
        component: React.lazy(() => import('views/app-views/agent/profile')),
    },
    {
        key: 'profile',
        path: `${APP_PREFIX_PATH}/profile`,
        component: React.lazy(() => import('views/app-views/agent/profile')),
    },
    {
        key: 'agent.help',
        path: `${APP_PREFIX_PATH}/agent/help`,
        component: React.lazy(() => import('views/app-views/agent/help')),
    },
    {
        key: 'pages.terms',
        path: `${APP_PREFIX_PATH}/pages/terms`,
        component: React.lazy(() => import('views/app-views/pages/terms')),
    },
    {
        key: 'pages.privacy',
        path: `${APP_PREFIX_PATH}/pages/privacy`,
        component: React.lazy(() => import('views/app-views/pages/privacy')),
    }
]
